<ion-content scrollY="false">
  <ion-list lines="full">

    @if (permissionService.isPermitted('pos-orders-payments-edit-payment')) {
      <ion-item button="true" (click)="presentOrderPaymentEditModal()">
        <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
      </ion-item>
    }

  </ion-list>
</ion-content>
